<template>
  <div>
    <check-number v-if="visibility.checkNumber" @submited="checkNumber" />

    <transition name="fade">
      <check-password
        v-if="visibility.checkPassword"
        @submited="checkPassword"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

import CheckNumber from "./components/CheckNumber";
import CheckPassword from "./components/CheckPassword";

export default {
  mixins: [validationMixin],
  name: "login",
  title: "ورود به سایت",
  components: {
    CheckNumber,
    CheckPassword,
  },
  data() {
    return {
      // Remove this dummy login info
      form: {
        phoneNumber: "",
        password: "",
      },
      visibility: {
        checkNumber: true,
        checkPassword: false,
      },
      message: "",
    };
  },
  validations: {
    form: {
      phoneNumber: {
        required,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    checkNumber(number, loginSpan, loginButton) {
      loginButton.classList.add("waiting");
      loginSpan.classList.add("button--loading");
      this.$store
        .dispatch("auth/checkNumber", number)
        // go to which page after successfully login
        .then(({ data }) => {
          this.$store.commit('auth/setRegisterNumber', number);
          
          if (data.result && data.status) {
            this.form.phoneNumber = number;
            this.visibility.checkNumber = false;
            this.visibility.checkPassword = true;
          } else {
            this.$router.push({ name: "register" });
          }
        });
    },
    checkPassword(password, loginSpan, loginButton) {
      loginButton.classList.add("waiting");
      loginSpan.classList.add("button--loading");

      this.form.password = password;
      this.onSubmit(loginSpan, loginButton);
    },
    onSubmit(loginSpan, loginButton) {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const Username = this.$v.form.phoneNumber.$model;
      const Password = this.$v.form.password.$model;
      const RememberMe = false;
      const grant_type = "password";

      // clear existing errors
      this.$store.dispatch("auth/logout");

      this.$store
        .dispatch("auth/login", {
          Username,
          Password,
          RememberMe,
          grant_type,
        })
        // go to which page after successfully login
        .then(() => {
          // console.log(data);
          this.$router.push({ name: "dashboard" });
        })
        .catch(function (error) {
          console.log('error is ', error);
        }).finally(() => {
          loginButton.classList.remove("waiting");
          loginSpan.classList.remove("button--loading");
        });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
};
</script>
